import React, { useState } from "react";
// import { ChevronLeft } from 'react-iconly';
import nookies from 'nookies';

import { useRouter } from "next/router";
import Button from "./Button";
import JWT from 'api/ssr/jwt';


type IProps = {
  title?: any;
  logout?: boolean
};

const Navbar: React.FC<IProps> = ({
  title,
  logout
}: IProps) => {
  const [email, setEmail] = useState<string>('');
  const router = useRouter();

  const onClickHandle = () => {
      nookies.destroy(null, 'user', {
        path: '/',
      });
      nookies.destroy(null, 'email', {
        path: '/',
      });
      nookies.destroy(null, 'jwt', {
        path: '/',
      });

     router.push('/auth/login');
  };

  React.useEffect(() => {
    if (JWT.getJwtUser()) {
      setEmail(JWT.getJwtUser().email);
    }
  }, [])

  return (
    <div className="flex-shrink-0 min-h-24 bg-dark-200">
      <div
        className={`flex flex-row items-center min-h-24 px-7 tablet:px-4 py-5 md:pr-7 justify-between flex-wrap`}
      >
        <div className="flex flex-row">
          <div className="w-32 mobile:w-20">
            <img
              src="/images/logo-blindspot-darkmode.svg"
              width="280"
              height="115"
              alt="Blindspot"
            />
            {/* <div className='flex flex-row flex-nowrap item-center'>
                <div className='flex items-center'>
                    <p className="pr-1 formerly">Formerly</p>
                </div>
                <div>
                    <img src="/images/logo-tps.png" width="50" alt="TPSEngage" className="block" />
                </div>
            </div> */}
          </div>
          <div
            className="items-center hidden text-xl text-white border-l-2 ml-7 border-dark-300 border-opacity-40 pl-7 md:flex"
            dangerouslySetInnerHTML={{ __html: title }}
          ></div>
        </div>
        <div className="flex-1">
          <div className="flex items-center tablet:items-end justify-end tablet:flex-col">
            {logout && 
              <>
              <h1 className="tablet:hidden mr-3 text-dark-300">Connected with:</h1>
              <div className="mr-4 text-dark-300 tablet:mr-0 text-center bg-lightGrey bg-opacity-20 px-2 py-1 rounded-xl tablet:bg-dark-200 tablet:px-0">
                {email}
              </div>
              </>
            }
            {!logout && 
              <h1 className="mr-4 text-dark-300 tablet:mr-0 text-center">
                Need more information about us?
              </h1>
            }
            
            {!logout && (
              <a
                href="https://seeblindspot.com/"
                target="_blank"
                rel="noreferrer"
                className="font-semibold text-primarydark-default"
              >
                Visit our website
              </a>
            )}
            {logout && (
              <h1
                onClick={onClickHandle}
                className="font-semibold text-primarydark-default cursor-pointer"
              >
                Logout
              </h1>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Navbar;
